const characters = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  ç: 'c',
  ý: 'y',
  ÿ: 'y',
};

export default function (str) {
  const word = str.toLowerCase();
  if (typeof word === 'string') {
    return word.replace(/[^A-Za-z0-9]/g, x => characters[x] || x);
  }
  return word;
}
